import React, { useEffect, useState } from 'react';
import { AutoResizer } from 'react-base-table';
import { Retry } from '@components/common';
import { isEmpty } from 'lodash';
import { TableWrapper, StyledBaseTable } from './styled';
import columns from './Columns';
import { buildViewingExpData, getErrorMetric } from '../common/utils';
import ShowErrorBox from './ShowErrorBox';

const ViewingExperience = ({ sessionAverage, cityAverage, asnAverage, rowData }) => {
  const [tableData, setTableData] = useState([]);
  const playStatus = rowData.Status;
  const sessionStatus = sessionAverage.status;
  const cityStatus = cityAverage.status;
  const asnStatus = asnAverage.status;
  const onRefetch = () => {
    if (cityStatus === 'error') {
      cityAverage.refetch();
    }
    if (sessionStatus === 'error') {
      sessionAverage.refetch();
    }
    if (asnStatus === 'error') {
      asnAverage.refetch();
    }
  };
  const isLoadingStatus = cityStatus === 'loading' || asnStatus === 'loading' || sessionStatus === 'loading';
  const isSuccessStatus = cityStatus === 'success' && asnStatus === 'success' && sessionStatus === 'success';
  const isErrorStatus = cityStatus === 'error' || asnStatus === 'error' || sessionStatus === 'error';
  const isIdleStatus = cityAverage.isIdle || asnAverage.isIdle || sessionAverage.isIdle;
  const showErrorBox = !['Played', 'Not Played'].includes(playStatus);
  useEffect(() => {
    if (isSuccessStatus) {
      const sessionData = sessionAverage.data ? sessionAverage.data.data.data : {};
      const cityData = cityAverage.data ? cityAverage.data.data.data : {};
      const asnData = asnAverage.data ? asnAverage.data.data.data : {};
      setTableData(buildViewingExpData(sessionData, cityData, asnData, playStatus));
    }
  }, [isSuccessStatus, setTableData, sessionAverage, cityAverage, asnAverage, playStatus]);
  const errorMetric = getErrorMetric(playStatus);
  const { errorList } = rowData;

  return (
    <>
      <TableWrapper>
        <Retry
          isLoading={isLoadingStatus || isIdleStatus}
          showError={isErrorStatus}
          isEmpty={isEmpty(tableData)}
          mountChildAlways={false}
          fetchData={onRefetch}
        >
          <AutoResizer>
            {({ width, height }) => (
              <StyledBaseTable
                data={tableData}
                columns={columns}
                headerHeight={50}
                rowHeight={45}
                fixed={false}
                width={width}
                height={height}
              />
            )}
          </AutoResizer>
        </Retry>
      </TableWrapper>
      {showErrorBox
        ? (
          <ShowErrorBox
            metric={errorMetric}
            errorList={errorList}
          />
        ) : null}
    </>
  );
};

export default ViewingExperience;
